import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Warning = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.089 17.7752C13.089 18.3767 12.6014 18.8643 12 18.8643C11.3985 18.8643 10.911 18.3767 10.911 17.7752C10.911 17.1738 11.3985 16.6862 12 16.6862C12.6014 16.6862 13.089 17.1738 13.089 17.7752Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7.15729C12.4511 7.15729 12.8168 7.52297 12.8168 7.97406V14.5082C12.8168 14.9593 12.4511 15.3249 12 15.3249C11.5489 15.3249 11.1832 14.9593 11.1832 14.5082V7.97406C11.1832 7.52297 11.5489 7.15729 12 7.15729Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.4312 18.8643L12.9431 4.16249C12.5239 3.43648 11.476 3.43648 11.0569 4.16249L2.56881 18.8643C2.14964 19.5903 2.6736 20.4978 3.51192 20.4978H20.4881C21.3264 20.4978 21.8503 19.5903 21.4312 18.8643ZM14.8293 3.07347C13.5719 0.895433 10.4281 0.89543 9.17064 3.07347L0.682568 17.7752C-0.574924 19.9533 0.996937 22.6758 3.51192 22.6758H20.4881C23.003 22.6758 24.5749 19.9533 23.3174 17.7752L14.8293 3.07347Z",
      fill: color
    })]
  });
};
export { Warning };